import React, { useState } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { useLocation } from 'react-router-dom';

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import '../../styles/pages/PdfViewer.scss';

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};

export default function PdfViewerPage() {
  const urlParam = new URLSearchParams(useLocation().search).get('url');
  const [file, setFile] = useState(urlParam);
  const [numPages, setNumPages] = useState(null);

  function onFileChange(event) {
    setFile(event.target.files[0]);
  }

  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }

  return (
    <div className="Example">
      <div className="Example__container">
        <div className="Example__container__document">
          <Document file={file} onLoadSuccess={onDocumentLoadSuccess} options={options}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page key={`page_${index + 1}`} pageNumber={index + 1} />
            ))}
          </Document>
        </div>
      </div>
    </div>
  );
}